export default function BrandLogo({ onClick, href }: { onClick?: (e: React.MouseEvent) => void; href?: string }) {
  const logoUrl = 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/c83dae1e-7225-4e53-9db7-b0dd5797829b_compressed_logo-villas-yaiza-2026.webp';

  const content = (
    <img
      src={logoUrl}
      alt="Yaiza Villas Holiday"
      className="h-10 md:h-14 w-auto object-contain"
    />
  );

  if (href) {
    return (
      <a
        href={href}
        onClick={onClick}
        className="flex items-center transition-opacity duration-300 hover:opacity-80"
      >
        {content}
      </a>
    );
  }

  return <div className="flex items-center">{content}</div>;
}